// extracted by mini-css-extract-plugin
export default {"equal-size-flex-row__item":"EqualSizeFlexRow_equal-size-flex-row__item__O+y01"};